import { Content } from '@/lib';
import YouTube from '../YouTube/YouTube';

export function Embed(props: Content.Embed) {
  // eslint-disable-next-line react/destructuring-assignment
  switch (props.service) {
    case Content.EmbedServices.youtube:
      return <YouTube {...props} />;
    default:
      return (
        <div
          style={{
            padding: '20',
            background: 'var(--green-lighter)',
          }}
        >
          {/* eslint-disable-next-line react/destructuring-assignment */}
          Embed with service <b>{props.service}</b> currently not supported
        </div>
      );
  }
}
